export type ApiErrorCode =
  | "unauthorized"
  | "forbidden"
  | "account_locked"
  | "rate_limited"
  | "validation_failed"
  | "not_found"
  | "conflict"
  | "server_error"
  | "network_error"
  | "unknown";

export interface ApiErrorShape {
  code: ApiErrorCode;
  status: number;
  message: string;
  requestId?: string;
  details?: unknown;
}

export class ApiError extends Error implements ApiErrorShape {
  readonly code: ApiErrorCode;
  readonly status: number;
  readonly requestId?: string;
  readonly details?: unknown;

  constructor(shape: ApiErrorShape) {
    super(shape.message);
    this.name = "ApiError";
    this.code = shape.code;
    this.status = shape.status;
    if (shape.requestId !== undefined) this.requestId = shape.requestId;
    if (shape.details !== undefined) this.details = shape.details;
  }
}

export function isApiError(value: unknown): value is ApiError {
  return value instanceof ApiError;
}
